import _ from 'lodash';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { uniqueKey } from '../../../../global/common/keys';
import { updateArrayInclusion } from '../../../../global/common/sorting';
import { gEnums } from '../../../../global/enums/globalEnums';
import { matchScheduleTypes, SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { gameScoringTypes } from '../../cnr/reducers/SportsSeasonReducer';
import { CreatePlayoffContext } from '../../create/CreatePlayoff';
import LevelSchedulesWithProvider from '../schedule/LevelSchedules';
import TeamRecord from '../teams/TeamRecord';
import { SportsStandingsContext } from './LeagueStandings';
import MotionPlaceholder from 'global/motions/MotionPlaceholder';
import { filterHelpers } from 'global/common/filtering';
import { useFindProps, useStateProps } from 'global/cnr/contexts/useHelpers/useStateProps';
import MotionDiv from 'global/motions/MotionDiv';
import { motion } from "framer-motion";

const _allowSelect = false

const _tris = {
  l: 'l',
  mr: 'mr',
  n: 'n',
  nsl: 'nsl',
  nst: 'nst',
  nsw: 'nsw',
  op: 'op',
  p: 'p',
  sl: 'sl',
  smr: 'smr',
  sp: 'sp',
  st: 'st',
  sw: 'sw',
  t: 't',
  w: 'w',
}

export const _teamNames = ['Catholic', 'Christian', 'Academy', 'County']
export const _teamNamesReplace = ['Cath.', 'Christ.', 'Acad.', 'Co.']

const SectionStandings = (props) => {

  // forPlayoff will indicate the teams selected and
  // showMatchesRemainingCount && showMatchesRemainingCount

  const _asat = gEnums.availableSubActionTypes
  const { sectionOpts } = props
  const { teams,
    selectedTeam,
    selectedTeams,
    caption,
    teamOnly,
    forOverview,
    forPlayoff,
    isFavSection } = sectionOpts

  // parentContext
  const parentContext = useContext(ParentContext);
  const { fns, states } = parentContext ?? {}
  const { appUser_state } = states ?? {}
  const { navigation_fns } = fns

  // authContext 
  const { appUser } = appUser_state ?? {}
  const { profileData } = appUser ?? {}
  const { favs_info } = profileData ?? {}
  const { eventFavs } = favs_info ?? {};
  const team_favs = eventFavs && eventFavs['teams']

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_fns, sportsSeason_handlers, sportsSeason_state } = sportsSeasonContext ?? {}
  const { teams_info, details_info, currentSeason_info, sportsSeason_info, sportSettings_info, links_score } = sportsSeason_state ?? {}
  const { showRankingsInStandings } = sportSettings_info ?? {}
  const { playoffTeams: playoffTeams_season } = teams_info ?? {}
  const { details, sectionPlayoffTeams } = details_info ?? {}
  const { playoffTeamsPerSection } = details ?? {}
  const { showMatchesRemainingCount } = sportsSeason_info ?? {}
  const { sortStandingsByPoints } = links_score ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}

  // console.log('teams_info', teams_info)

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { subActionType, playoff_info } = createPlayoff_state ?? {}
  const { playoffTeams, playoffTeamCompares } = playoff_info ?? {}

  const sportsStandingsContext = useContext(SportsStandingsContext)
  const { sportsStandings_state, sportsStandings_handlers } = sportsStandingsContext ?? {}
  const { showSelected, selfhandleSelectClickected_teams, showPlayoffPicture } = sportsStandings_state ?? {}

  const allowSelect = (subActionType === _asat.createPlayoff)

  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // render once, stop observing
        }
      },
      { rootMargin: "200px" } // preload a bit before visible
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const sortedTeams = useMemo(() => {
    if (sportsSeason_fns && teams) {
      return sportsSeason_fns.sortSectionStandings(
        teams,
        playoffTeamsPerSection,
        sectionPlayoffTeams,
        _sportsModeSport,
        forPlayoff,
        sortStandingsByPoints
      );
    }
    return {};
  }, [teams, JSON.stringify(playoffTeams)]);

  const [selected_team, setSelectedTeam] = useState()
  const [showRemaining, setShowRemaining] = useState()

  const handleSelectedTeams = (team) => {
    const _sts = [...selected_teams]
    updateArrayInclusion(_sts, team._itemKey)
    sportsStandings_handlers.handleSet_selected_teams(_sts)
  }

  let cellCount = 0
  const tableType = 'tst'

  const isNonSection = false

  let valueW = 2
  // let spanW = 4
  // let nameW = 8

  // switch (gameScoringType) {
  //   case gameScoringTypes.match:
  //     nameW = 8
  //     spanW = 4
  //     break;
  //   default:
  //     nameW = 6
  //     spanW = 6
  //     break;
  // }



  const handleTeamClick = (e, team) => {
    if (forPlayoff) {
      _allowSelect && setSelectedTeam(selected_team ? null : team)
      createPlayoff_handlers.handleSelect_playoffTeamRecord(team)
      if (allowSelect) {
        allowSelect && handlePlayoffClick(e, team, true)
      }
    } else {
      team && navigation_fns && sportsSeason_handlers.handleGoTo_team(navigation_fns, team)
    }
  }

  const handlePlayoffClick = (e, team, compareOnly) => {
    if (e) { e.cancelBubble = true };
    if (e && e.stopPropagation) e.stopPropagation();
    createPlayoff_handlers.handleSelect_playoffTeam(team, compareOnly)
  }

  const handleSelectClick = (e, team) => {
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    handleSelectedTeams(team)
  }

  const teamRecordDiv = (record) => {

    let trs = []

    const cells = []

    switch (gameScoringType) {
      case gameScoringTypes.match:
      case gameScoringTypes.matchPoints:
      case gameScoringTypes.inning:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl]
            } else {
              trs = [_tris.sw, _tris.sl]
            }
            if (gameScoringType === gameScoringTypes.matchPoints) {
              trs.push(_tris.p)
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            if (gameScoringType === gameScoringTypes.matchPoints) {
              trs.push(_tris.op)
            }
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;

      case gameScoringTypes.half:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst, _tris.nsp]
            } else {
              trs = [_tris.sw, _tris.sl, _tris.st, _tris.sp]
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            trs.push(_tris.t)
            trs.push(_tris.op)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;

      case gameScoringTypes.quarter:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst]
            } else {
              if (gameAllowTies) {
                trs = [_tris.sw, _tris.sl, _tris.st]
              } else {
                trs = [_tris.sw, _tris.sl]
              }
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            gameAllowTies && trs.push(_tris.t)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              gameAllowTies && trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              gameAllowTies && trs.push(_tris.n)
            }
          }
        }
        break;

      default:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst, _tris.nsp]
            } else {
              trs = [_tris.sw, _tris.sl, _tris.st, _tris.sp]
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            trs.push(_tris.t)
            trs.push(_tris.op)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;
    }

    trs.forEach(t => {
      switch (t) {
        case _tris.n:
          cells.push(recordDiv(0, valueW))
          break;
        default:
          cells.push(recordDiv(record[t], valueW))
      }

    })

    return cells
  }

  const standingsHeader = () => {
    let cn = 'standing-section-header'
    let hdrs1;
    if (isNonSection) {
      hdrs1 = ['P', '#', 'team', 'SW', 'SL']
    } else {
      if (tableType === 'normal') {
        hdrs1 = ['team', 'section', 'nonSection', 'w', 'l', 'w', 'l']
      } else {
        switch (gameScoringType) {
          case gameScoringTypes.match:
            hdrs1 = ['section', 'overall', 'team', 'w', 'l', 'ow', 'ol']
            break;
          case gameScoringTypes.matchPoints:
            hdrs1 = ['section', 'overall', 'team', 'w', 'l', 'p', 'ow', 'ol', 'op']
            cn += ' pts'
            break;
          case gameScoringTypes.quarter:
            if (gameAllowTies) {
              hdrs1 = ['section', 'overall', 'team', 'w', 'l', 't', 'ow', 'ol', 'ot']
            } else {
              hdrs1 = ['section', 'overall', 'team', 'w', 'l', 'ow', 'ol']
            }
            break;
          case gameScoringTypes.half:
            hdrs1 = ['team', 'section', 'overall', 'w', 'l', 't', 'p', 'ow', 'ol', 'ot', 'op']
            break;
          case gameScoringTypes.inning:
            hdrs1 = ['team', 'section', 'overall', 'w', 'l', 'ow', 'ol']
            break;
          default:
            hdrs1 = ['team', 'section', 'overall', 'w', 'l', 't', 'p', 'ow', 'ol', 'ot', 'op']
        }
      }
    }
    return <div key={uniqueKey('ss', 'sh')} className={cn}>
      {hdrs1.map((hi, index) => {
        const _hi = hi.length === 2 ? hi.replace('o', '') : hi
        return <div key={uniqueKey('ss', 'sh', index)} className={'ss-' + hi}>{_.startCase(_hi)}</div>
      })}
    </div>
  }

  const handleShowRemaining = () => setShowRemaining(!showRemaining)
  // const teamIcon = (team, rowKey, key, defaultImage) => {
  //   const def = (defaultImage) ? defaultImage : 'volleyball'
  //   return <Image key={uniqueKey('ss', 'rc', rowKey, key)} size={settings.imageSize} src={icons.getTeamIcon(team)} className={styles.teamRowIcon} onError={e => e.target.src = '/images/' + def + '.png'} />
  // }


  const recordDiv = (value, width) => {
    cellCount++
    return <div key={uniqueKey('ss', 'rc', cellCount)} >{value}</div>
  }

  const sectionRankLabel = (team, sectionRank, _selected) => {

    const handleClick_label = (e) => {
      e.stopPropagation()
      allowSelect && handlePlayoffClick(e, team)
      showPlayoffPicture && handleSelectClick(e, team)
    }

    let cn;
    if (showPlayoffPicture) {
      cn = 'srl-pp'
      if (_selected) {
        cn += '-sel'
      }
    }

    const playoffTeam = playoffTeams && team ? _.find(playoffTeams, { id: team._itemKey }) : null
    const checked = playoffTeam ? true : false
    const colorSelect = checked ? 'green' : 'grey'
    let color = allowSelect ? colorSelect : null
    return <Label size={'mini'} className={cn} onClick={(e) => { handleClick_label(e) }} color={color} >{sectionRank}</Label>
  }

  const matchRemainingLabel = (smr, mr) => <Label size='mini' className='sssmr' title={'Remaining (section:all)'}>
    <Icon name='caret right' />{smr}{':'}{mr}
  </Label>

  const currentRankLabel = (currentRank) => <Label size={'mini'} className={'team-rank'} circular>{currentRank}</Label>
  const sectionLabel = (sectionRank) => <Label size='mini'>{sectionRank}</Label>

  const teamName = (name) => {
    let _name = name
    for (let i = 0; i < _teamNames.length; i++) {
      if (name.includes(_teamNames[i])) {
        _name = name.replace(_teamNames[i], _teamNamesReplace[i]);
      }
    }
    return _name
  }

  const standingsTeamRow = (team, rowKey, rowCn, firstCn, index, _selected) => {

    const { name, record, _itemKey, currentRank, teamNumber } = team ?? {}
    const { playoffTeam, nonPlayoffTeam, playoffEliminated, playoffAssured, sectionRank, smr, mr, tmm } = record ?? {}

    const playoffTeamCompare = playoffTeamCompares && team ? _.find(playoffTeamCompares, { id: team._itemKey }) : null

    const _name = teamName(name)
    const _firstCn = _name.length > 14 ? firstCn + ' nmr' : firstCn

    const isFav = team_favs && team_favs[_itemKey] ? true : false
    let _rowCn = 'standing-team smr'
    _rowCn += isFav ? ' fav' : ''
    _rowCn += gameScoringType === gameScoringTypes.matchPoints ? ' pts' : ''
    _rowCn += ' ' + rowCn

    if (playoffTeamCompare) { _rowCn += ' ptc' }

    const _rowFavIcon = isFav ? <Icon className={'ssfav'} name={'star'} color={'blue'} size={'tiny'} /> : null

    if (isNonSection) {
      return <div key={uniqueKey('ss', 'sr', rowKey)} className={_rowCn}>
        <div>{index + 1}</div>
        <div>{'#' + teamNumber}</div>
        <div>{_name}</div>
      </div>
    } else {

      // adjust the class for the row
      if (playoffTeam) { _rowCn += ' ss-pt' }
      if (nonPlayoffTeam) { _rowCn += ' ss-npt' }
      if (playoffEliminated) { _rowCn += ' ss-npte' }
      if (playoffAssured) { _rowCn += ' ss-npta' }
      if (tmm && tmm > 0) { _rowCn += ' ss-mm' }

      return <div key={uniqueKey('ss', 'sr', rowKey)} className={_rowCn} onClick={(e) => handleTeamClick(e, team)}>
        <div className={_firstCn}>
          {sectionRankLabel(team, sectionRank, _selected)}
          {_name}
          {_rowFavIcon}
          {showRankingsInStandings && currentRank && currentRankLabel(currentRank)}
          {!forPlayoff && (mr > 0) && showMatchesRemainingCount > smr && matchRemainingLabel(smr, mr)}
          {forPlayoff && sectionLabel(sectionRank)}
        </div>
        {teamRecordDiv(record)}
      </div>
    }
  }

  const getSelectedStandings = () => {
    const _selected = []
    const _teams = Object.values(sortedTeams)
    const index = _.findIndex(_teams, { key: selectedTeam });
    const before = _teams[index - 1];
    const selected = _teams[index];
    const after = _teams[index + 1];
    _selected.push(before)
    _selected.push(selected)
    _selected.push(after)
    return _selected;
  }

  const standingsTeamRows = () => {

    const rows = []
    let _sortedTeams;

    if (forOverview) {
      _sortedTeams = getSelectedStandings()
    } else {
      _sortedTeams = sortedTeams
    }

    let rowIndex = 0;

    // loop the teams
    _.forEach(_sortedTeams, (team, teamKey) => {
      const rowKey = 'r' + rowIndex
      if (team) {
        const selected = selectedTeam === team.id
        const _selected = selected_teams && (selected_teams.includes(team.id))
        let cellCn = null
        let rowCn = team && (selected) ? 'standings-selected' : null
        if (team && selectedTeams && selectedTeams.includes(team.id)) { rowCn = 'standings-selected' }

        let allowTeam = true

        if (showSelected && selected_teams) {
          if (!selected_teams.includes(team.id)) {
            allowTeam = false
          }
        }

        if (allowTeam) {
          rows.push(standingsTeamRow(team, rowKey, rowCn, cellCn, rowIndex, _selected))
          if (showPlayoffPicture && _selected) {
            rows.push(<TeamRecord team={team} selected_teams={selected_teams} />)
          }
          if (showRemaining) {
            rows.push(<div className={'matches-latest-team remaining'}
            ><LevelSchedulesWithProvider
                matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.teamScheduleRemaining}
                matchScheduleType={matchScheduleTypes.levelMatches}
                teamKey={team.id}
                forPlayoff={forPlayoff}
              /></div>)
          }
        }
      }
      rowIndex++
    })

    return rows
  }

  const standingsSection = () => {
    const items = []
    items.push(<div key={uniqueKey('ss', 'si')} className='standing-section'>
      {standingsTeamRows()}
    </div>)
    // items.unshift(tableHeader())
    return items
  }

  const content = () => <MotionDiv>
    <div>
      {standingsHeader()}
      {standingsSection()}
    </div>
  </MotionDiv>

  let cn = 'standings-container'
  if (teamOnly) { cn += ' team' }

  let cnt = 'standings-table ' //  + gameScoringType

  switch (gameScoringType) {
    case gameScoringTypes.half:
      cnt += 'ties'
      break;
    default:
      cnt += 'no-ties'
      break;
  }

  if (gameScoringType === gameScoringTypes.matchPoints) {
    cnt += ' pts'
  }

  return <div
    ref={ref}
    className={cn}
    key={uniqueKey('ss', 's', 'sg')}
  >
    {!forOverview && !forPlayoff && <div key={uniqueKey('ss', 's', 'sh')} className={'standings-header'}>
      {isFavSection ? <div><Icon name={'star'} color={'blue'} /></div> : <div></div>}
      <div>{caption}</div>
      <div><Icon name='calendar outline' color={showRemaining ? 'blue' : 'grey'} onClick={(e) => { handleShowRemaining(e) }} /></div>
    </div>
    }
    <div key={uniqueKey('ss', 's', 'st')} className={cnt}>
      {isVisible ? (
        <div className='match-date-matches'>
          {content()}
        </div>
      ) : (
        <MotionPlaceholder />
      )}
    </div>
  </div>
}

export default SectionStandings 